@let item = attachment();
<interacta-live-status
    [message]="
        item.isCanceled
            ? ('DASHBOARD.ATTACHMENTS.ACCESSIBILITY.UPLOAD_CANCELED'
              | translate: { name: item.name })
            : null
    "
/>
<p aria-atomic="true" class="sr-only" role="alert">
    @if (item.isLoadingError) {
        {{
            'DASHBOARD.ATTACHMENTS.ACCESSIBILITY.UPLOAD_ERROR'
                | translate: { name: item.name }
        }}
    }
</p>
@if (attachment(); as attachment) {
    <div
        class="flex h-52 items-center justify-between"
        (focusin)="hoverRow.set(true)"
        (focusout)="hoverRow.set(false)"
        (mouseenter)="hoverRow.set(true)"
        (mouseleave)="hoverRow.set(false)"
    >
        <div class="flex items-center space-x-8">
            <interacta-image
                alt=""
                classes="w-24 h-24"
                [src]="attachment.iconPath || ''"
            />

            <span class="line-clamp-1 text-left typo-sm break-all">{{
                attachment.name
            }}</span>
        </div>

        @if (attachment.uploadProgress) {
            @if (attachment.uploadProgress < 100 && !hoverRow()) {
                <interacta-progress-loader
                    [matTooltip]="attachment.uploadProgress + '%'"
                    [progress]="attachment.uploadProgress"
                />
            }
            @if (attachment.uploadProgress < 100 && hoverRow()) {
                <button
                    interacta-icon-button
                    type="button"
                    [icon]="'close'"
                    [label]="'SHARED.FILE_UPLOAD.CANCEL_UPLOAD' | translate"
                    [size]="'regular'"
                    [style]="'text'"
                    (click)="cancelUpload.emit()"
                ></button>
            }
            @if (attachment.uploadProgress === 100) {
                <div
                    (focusin)="hoverSuccessIcon.set(true)"
                    (focusout)="hoverSuccessIcon.set(false)"
                    (mouseenter)="hoverSuccessIcon.set(true)"
                    (mouseleave)="hoverSuccessIcon.set(false)"
                >
                    @if (attachment.id == null) {
                        <interacta-progress-loader
                            [matTooltip]="'UPLOAD.SAVING' | translate"
                            [progress]="100"
                        />
                    }

                    @if (attachment.id != null) {
                        @if (!hoverSuccessIcon() || !attachment.post) {
                            <interacta-icon
                                class="h-24 w-24 text-system-success"
                                [icon]="'check'"
                            />
                        }
                        @if (attachment.post && hoverSuccessIcon()) {
                            <a
                                interacta-icon-button
                                [icon]="'external-link'"
                                [label]="'UPLOAD.GOTO_POST' | translate"
                                [routerLink]="['/post', attachment.post.id]"
                                [size]="'regular'"
                                [style]="'text'"
                            ></a>
                        }
                    }
                </div>
            }
        }
        @if (attachment.isLoadingError) {
            <div
                (focusin)="hoverError.set(true)"
                (focusout)="hoverError.set(false)"
                (mouseenter)="hoverError.set(true)"
                (mouseleave)="hoverError.set(false)"
            >
                <button
                    class="text-text-error"
                    interacta-icon-button
                    type="button"
                    [icon]="hoverError() ? 'retry' : 'warning'"
                    [label]="'UPLOAD.UPLOAD_ERROR_RETRY' | translate"
                    [size]="'regular'"
                    [style]="'text'"
                    (click)="retryUpload.emit()"
                ></button>
            </div>
        }
        @if (attachment.isCanceled) {
            <div class="shrink-0 typo-xs">
                {{ 'UPLOAD.UPLOAD_CANCELED' | translate }}
            </div>
        }
    </div>
}
